import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileComponent } from './profile/profile.component';
import { SettingsNavLayoutComponent } from '../shared/layout/settings-nav-layout/settings-nav-layout.component';
import ActivityLogsComponent from './activity-logs/activity-logs.component';
import { DevicesComponent } from './devices/devices.component';
import { SecurityComponent } from './security/security.component';
import { BrandingComponent } from './branding/branding.component';
import { BillingComponent } from './billing/billing.component';
import { BillingProfileComponent } from './billing-profile/billing-profile.component';
import { UpgradePlanComponent } from './upgrade-plan/upgrade-plan.component';

const routes: Routes = [
  {
    path: '', component: SettingsNavLayoutComponent,
    children: [
      { path: '', redirectTo: 'profile', pathMatch: 'full'},
      { path: 'profile', component: ProfileComponent, title: 'Profile | Sync.com' },
      { path: 'billing', component: BillingComponent, title: 'Billing | Sync.com' },
      { path: 'billing/profile', component: BillingProfileComponent, title: 'Billing | Sync.com' },
      { path: 'events', component: ActivityLogsComponent, title: 'Events | Sync.com' },
      { path: 'devices', component: DevicesComponent, title: 'Devices | Sync.com' },
      { path: 'security', component: SecurityComponent, title: 'Security | Sync.com' },
      { path: 'branding', component: BrandingComponent, title: 'Branding | Sync.com'},
      { path: 'upgrade-plan', component: UpgradePlanComponent, title: 'Upgrade | Sync.com'},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule { }
